export class Brod2SalesChannelValueConverter {
  static x = {
    GROCERY_STORE: 'Dagligvare',
    HOSPITALITY: 'Servering',
    KIOSK: 'Kiosk',
    FUEL_STATION: 'Bensin / energistasjon',
    VINMONOPOLET: 'Vinmonopol',
  };

  toView(value) {
    return Brod2SalesChannelValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
